/**
 * Collaboratori Page - Page Shell
 * Lista team
 */

import { TeamList } from "@/features/collaboratori";

export default function Collaboratori() {
  return <TeamList />;
}
